import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;
const INVITATIONS = 'invitations';

export default class InvitationService {

    static async create(requestBody) {
        return ApiService.PostData(API_URLS.INVITATION, requestBody, INVITATIONS);
    }

    static async resend(loanId) {
        return ApiService.PatchData(`${API_URLS.INVITATION_RESEND}/${loanId}/resend`, {}, INVITATIONS);
    }

    static async resendToNewUser(loanId, requestBody) {
        return ApiService.PatchData(`${API_URLS.INVITATION_RESEND}/${loanId}`, requestBody, INVITATIONS);

    }

    static async linkValidation(requestBody) {
        return ApiService.PostData(API_URLS.INVITE_LINK_VALIDATE, requestBody, INVITATIONS);
    }

}
